export const UNSUPPORTED_SOLC_VERSIONS = []
